module.exports = __webpack_public_path__ + "static/media/UML.9b9edd22.png";